export class GetArtifactsParams {
  artifact_ids: Array<string>;
  suppressErrHandler: boolean;
  get_source: boolean = false;
}
